import * as React from 'react';

export interface SidebarDividerNextProps {
  dataHook?: string;
  fullWidth?: boolean;
}

export default class SidebarDividerNext extends React.PureComponent<SidebarDividerNextProps> {}
